<div class="wrapper">
    @if (contactsDatasource) {
        <div class="grid">
            <app-server-side-grid
                [colDefs]="gridColumns"
                [datasource]="contactsDatasource"
                [noRows]="noResults()"
                [titleNoData]="'No Contacts available.'"
            ></app-server-side-grid>
        </div>
    }
</div>
